import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllCallLog(page, user) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRelatedCalllog/${page}/${user}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CallLogDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/callLog/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCallLogId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/callLog/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CalllogSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveCallLog`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CalllogUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/callLog/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TwilioCalllogUpdate(description, callTitle, mobileNumber, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCallLogFromTwilio/${description}/${callTitle}/${mobileNumber}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCallLogFromTwilio(entityId, entityType, mobileNumber) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCallLogFromTwilio/${entityId}/${entityType}/${mobileNumber}`, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllCallLog,
    CallLogDetailData,
    deleteCallLogId,
    CalllogUpdate,
    CalllogSave,
    TwilioCalllogUpdate,
    getCallLogFromTwilio,
}